import React, { useEffect, useState } from "react";
import Section from "../../components/Section";
import { pageTitle } from "../../helpers/PageTitle";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import toast from "react-hot-toast";
import SecondaryButton from "../../components/SecondaryButton";
import { signInWithEmailAndPassword } from "firebase/auth";
import PageHeader from "../../components/PageHeader";
import InputField from "../../components/InputField";
import { auth } from "../../config/firebaseConfig";
import { BsEye } from "react-icons/bs";
import PasswordInputField from "../../components/PasswordField";
import axiosInstance from "../../utils/axiosInstance";
import { fetchDoctorProfile, registerUser, updateDoctorDetails, updateUserDetais } from "../../constants/ApiConstants";
import { Link, redirect, useNavigate } from "react-router-dom";
import SelectField from "../../components/SelectField";
import SelectField2 from "../../components/SelectField2";
import { countries } from "../../utils/countries";
import MobileNumberWithCountryCode from "../../components/MobileNumberWithCountryCode";
import DatePicker from "react-datepicker";
import { getYYYYmmddFromDate } from "../../utils/utils";
import { updateUserData } from "../../store/appSlice";
import TextAreaField from "../../components/TextAreaField";

export default function DoctorProfileSetupThree() {
  pageTitle("Complete PRofile Registration");

  const [loading, setLoading] = useState(false);
  const userData = useSelector((state) => state.appSlice.userData);
  const [clinicDetails, setClinicDetails] = useState("");
  const [clinicAddress, setClinicAddress] = useState("");
  const [clinicLocation, setClinicLocation] = useState("");
  const [clinicName, setClinicName] = useState(false);
  const [onlineConsulation, setOnlineConsultation] = useState(0);
  const [clinicConsultation, setCliniConsultation] = useState(0);
  const [submitting, setSubmitting] = useState(false);
  const [doctorDetail, setDoctorDetail] = useState("");

  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    fetchDoctorDetail();
  }, []);

  const fetchDoctorDetail = () => {
    setLoading(true);

    axiosInstance
      .post(fetchDoctorProfile, { doctor_id: userData.id })
      .then((res) => {
        setDoctorDetail(res?.data?.data);
        setOnlineConsultation(res?.data?.data?.online_consultation || 0);
        setCliniConsultation(res?.data?.data?.clinic_consultation || 0);
        setClinicName(res?.data?.data?.clinic_name || "");
        setClinicAddress(res?.data?.data?.clinic_address || "");
        setClinicLocation(res?.data?.data?.clinic_location || "");
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  const handleSubmitClick = async () => {
    // if (about === "") {
    //   toast.error("About yourself is required.");
    //   return;
    // }
    // if (educationalJourney === "") {
    //   toast.error("Educational Journey is required");
    //   return;
    // }
    // const payload = {
    //   doctor_id: userData?.id,
    //   about_youself: about,
    //   educational_journey: educationalJourney,
    // };
    // try {
    //   setLoading(true);
    //   const response = await axiosInstance.post(updateDoctorDetails, {
    //     ...payload,
    //   });
    //   if (response.data?.status) {
    //     toast.success("Doctor details has been updated.");
    //     dispatch(updateUserData(response?.data?.data));
    //     navigatePage(response?.data?.data);
    //   } else {
    //     toast.error(response.data?.message);
    //   }
    //   setLoading(false);
    // } catch (err) {
    //   console.log(err);
    //   // toast.error(err.response.data?.message);
    //   setLoading(false);
    // }
  };

  function navigatePage(doctorData) {
    console.log({ online: doctorData.online_consultation, clinic: doctorData?.clinic_consultation });
    if (!doctorData.category_id) {
      navigate("/select-category");
    } else if (!doctorData.image || !doctorData.designation || !doctorData.degrees || !doctorData.experience_year || !doctorData.consultation_fee) {
      navigate("/doctor-profile-setup/one");
    } else if (!doctorData.about_youself || !doctorData.educational_journey) {
      navigate("/doctor-profile-setup/two");
    } else if (doctorData.online_consultation == 0 && doctorData.clinic_consultation == 0) {
      navigate("/doctor-profile-setup/three");
    } else {
      navigate("/doctor-registration-success");
    }
  }

  const handleOnlineConsultationChange = (e) => {
    setOnlineConsultation(e.target.checked ? 1 : 0);
  };

  const handleClinicConsultationChange = (e) => {
    setCliniConsultation(e.target.checked ? 1 : 0);
  };

  return (
    <Wrapper>
      <Section topMd={200} topLg={150} topXl={110} bottomMd={200} bottomLg={150} bottomXl={110}>
        <div className="content-wrapper d-flex flex-column p-3 gap-1 justify-content-center">
          <div className="col-md-4 g-2">
            {/* <img className="img-fluid w-25 h-25 m-3" src="/images/logo.svg" /> */}
            <PageHeader title={"Complete Registration"} />
            <p className="fs-md text-grey2 p-2"></p>
            <strong className="my-0 text-dark">Choose consultation Type</strong>
            <span className="fs-md text-grey1 d-block my-0 ">You can change this later</span>
            <div className="d-flex align-items-center gap-2 mb-3">
              <div className="d-flex gap-2">
                <input type="checkbox" checked={onlineConsulation === 1} onChange={handleOnlineConsultationChange} />
                <strong className="text-grey2 fs-normal">Online</strong>
              </div>
              <div className="d-flex gap-2">
                <input type="checkbox" checked={clinicConsultation === 1} onChange={handleClinicConsultationChange} />
                <strong className="text-grey2 fs-normal">Clinic</strong>
              </div>
            </div>
            {clinicConsultation === 1 && (
              <>
                <strong className="my-0 text-dark">Add Clinic Details</strong>
                <span className="fs-md text-grey1 d-block my-0 mb-3">Where you will be consulting patients</span>
                <InputField label="Clinic Name" placeholder="Enter text..." inputType={"text"} value={clinicName} onChange={(e) => setClinicName(e.target.value)} />
                <TextAreaField rows={3} label="Clinic Address" placeholder="Enter here..." inputType={"text"} value={clinicAddress} onChange={(e) => setClinicAddress(e.target.value)} />
                <InputField label="Clinic Location" placeholder="Enter text..." inputType={"text"} value={clinicLocation} onChange={(e) => setClinicLocation(e.target.value)} />
                <SecondaryButton title={"Submit"} className={"mt-3"} onClick={handleSubmitClick} loading={submitting} />
              </>
            )}
          </div>
        </div>
      </Section>
    </Wrapper>
  );
}
const Wrapper = styled.div``;
